"use strict";

module.exports = (body) => {
  return (
    fetch($API_HOST + '/events/track', {
      headers: {
        'Accept': 'application/json',
        'Content-type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({software: "LANDING", ...body})
    })
  );
}